// extracted by mini-css-extract-plugin
module.exports = {"content":"_2ULtU","col":"YVyDP","left":"_2utX3","price":"_2xFBC","sku":"_2lYt5","right":"_1izec","actions":"_2Himj","options":"_1WshO","view-more":"_1gDpl","viewMore":"_1gDpl"};